import { findIdentifier } from '@lifeomic/fhir-constants';

const getIsDevHost = (hostname: string) =>
  [
    hostname.endsWith('.apps.dev.lifeomic.com'),
    hostname.endsWith('.localhost'),
    hostname === 'localhost',
  ].some(Boolean);

export const getElationPatientId = (
  patient?: fhir3.Patient | fhir.Patient | null,
): string | undefined => {
  const identifiers = patient?.identifier as fhir3.Identifier[] | undefined;
  return findIdentifier(identifiers, {
    system: system =>
      system?.includes('ehr:fountainlife:') && system?.endsWith('/Patient'),
  })?.value;
};

export const getElationPatientChartUrl = (
  elationId?: string,
  hostname?: string,
): string => {
  if (!elationId) {
    return '';
  }

  const resolvedHostname =
    hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : 'localhost');
  const elationSubdomain = getIsDevHost(resolvedHostname) ? 'sandbox' : 'app';

  return `https://${elationSubdomain}.elationemr.com/patient/${encodeURIComponent(
    elationId,
  )}/`;
};
